define('plugin/client-login/view/ClientLoginProfileView',['require','__original__/ClientLoginProfileView'],function (require) {

    var FormView = require('__original__/ClientLoginProfileView');

    /**
     * Client profile view
     *
     * @class ClientLoginProfileView
     */
    return FormView.extend({

        checkClientAccess: function () {
            if (!this.model.get('is_logged_in')) {
                this.model.navigateToSignIn();
            }
        },

    });

});
